import * as React from 'react';
import cx from 'classnames';
import { Box, PolymorphicComponentProps } from 'react-polymorphic-box';

import { Enum } from '../../common/types';

export const CKBoxVariant = Enum(
  'default',
  'card',
  'frame',
  'tinted',
  'tinted-frame',
  'well'
);
export type CKBoxVariant = Enum<typeof CKBoxVariant>;

export interface CKBoxOwnProps {
  variant?: CKBoxVariant;
  className?: string;
}

export interface CKBoxComposition {
  Variant: typeof CKBoxVariant;
}

export type CKBoxProps<E extends React.ElementType> = PolymorphicComponentProps<
  E,
  CKBoxOwnProps
>;

const defaultElement = 'div';

export const CKBox = (React.forwardRef(
  <E extends React.ElementType = typeof defaultElement>(
    { className, children, variant = 'default', ...props }: CKBoxProps<E>,
    innerRef: typeof props.ref
  ) => {
    const boxClass = cx(
      'ck-box',
      variant !== 'default' && `ck-box--${variant}`,
      className
    );
    return (
      <Box as={defaultElement} ref={innerRef} className={boxClass} {...props}>
        {children}
      </Box>
    );
  }
) as unknown) as CKBoxComposition &
  (<E extends React.ElementType = typeof defaultElement>(
    props: CKBoxProps<E>
  ) => JSX.Element);

CKBox.Variant = CKBoxVariant;
